var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._b({staticClass:"draggable_placeholder",attrs:{"list":[],"id":"modulesPlaceholder","group":"people"},on:{"change":_vm.addItemAtTheEnd}},'draggable',_vm.dragOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }